import {AfterViewChecked, ChangeDetectorRef, Component, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { EventEmitter } from '@angular/core';
import {
	FlattenSchemaEntry,
	JsonSchemaFlattenerService
} from '../../services/form/json-schema-flattener.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormValidatorService } from '../../services/form/form-validator.service';
import { SchemaRendererComponent } from '../../workflow/renderer/schema-renderer/schema-renderer.component';

export type FormRenderConfig = {
	viewOnly: boolean,
	parentForm: FormGroup,
};

@Component({
	selector: 'app-form-schema-renderer',
	templateUrl: './form-schema-renderer.component.html',
	styleUrls: ['./form-schema-renderer.component.scss']
})
export class FormSchemaRendererComponent extends SchemaRendererComponent implements OnChanges, OnInit, AfterViewChecked {
	formConfig: FormRenderConfig;

	@Output() emitFormSubmit = new EventEmitter<boolean>();
	@Output() emitFormValid = new EventEmitter<boolean>();
	@Input() readonly: boolean;
	@Input() formID: string;

	private flattenSchema: FlattenSchemaEntry[] = [];
	private validateForm: FormGroup;

	private flattenFormGroups: {[key: string]: unknown} = {};

	constructor(
		private fb: FormBuilder,
		private readonly changeDetectorRef: ChangeDetectorRef
	) {
		super();
		this.validateForm = new FormGroup({});
		this.formConfig = {
			viewOnly: true,
			parentForm: null,
		};
	}

	ngOnInit(): void {
		this.updateViewStatus();
	}

	ngAfterViewChecked(): void {
		this.changeDetectorRef.detectChanges();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.schema && this.schema) {
			this.resolveSchema(this.schema).then(() => this.initFormGroup());
		}

		if (changes.data) {
			this.updateData();
		}

		if (changes.readonly) {
			this.updateViewStatus();
		}

		this.isFormValid();
	}

	private initFormGroup(): void {
		this.flattenSchema = JsonSchemaFlattenerService.flatProperties(this.resolvedSchema);
		const disabled = this.formConfig.viewOnly;
		this.flattenFormGroups = {};
		for (const entry of this.flattenSchema) {
			this.flattenFormGroups[entry.key] = [
				{
					value: entry.schema.writeOnly ? null : this.data.getProperty(entry.key),
					disabled: disabled || entry.schema.readOnly,
				},
				FormValidatorService.getValidatorBySchema(entry.schema),
			];
		}

		this.validateForm = this.fb.group(this.flattenFormGroups);
		this.formConfig.parentForm = this.validateForm;
	}

	private updateViewStatus(): void {
		this.formConfig.viewOnly = this.readonly;

		this.readonly ?
			this.validateForm.disable() :
			this.validateForm.enable();
	}

	private updateData(): void {
		if (!this.validateForm) {
			return;
		}

		for (const entry of this.flattenSchema) {
			const control = this.validateForm.controls[entry.key];
			control?.setValue(entry.schema.writeOnly ? null : this.data.getProperty(entry.key));
		}
	}

	submitForm(): void {
		for (const i in this.validateForm.controls) {
			this.validateForm.controls[i].markAsDirty();
			this.validateForm.controls[i].updateValueAndValidity();
		}
		if (this.validateForm.valid) {
			for (const [key, value] of Object.entries(this.validateForm.value)) {
				this.data.setProperty(key, value);
			}

			this.emitFormSubmit.emit(true);
		}

		console.warn('SUBMIT', this.validateForm);
	}

	isFormValid(): void {
		for (const i in this.validateForm.controls) {
			this.validateForm.controls[i].markAsDirty();
			this.validateForm.controls[i].updateValueAndValidity();
		}
		this.emitFormValid.emit(this.validateForm.valid);
	}

	//Wird benötigt um im Datepicker die Fehlermeldung richtig zu deaktivieren
	change(event: unknown): void {}

	setValidationError(property: string, message: string): void {
		this.validateForm.controls[property]?.setErrors({ validation: message });
	}
}
